// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"2d0b0baf","86":"686c8457","184":"686c8457","219":"686c8457","639":"686c8457","955":"686c8457"}[chunkId] + ".chunk.css";
};